import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
  :root {
		--primary: ${({ theme }) => theme.primary};
    --secondary: ${({ theme }) => theme.secondary};
    --body: ${({ theme }) => theme.body};
    --primaryText: ${({ theme }) => theme.text};
    --secondaryText: ${({ theme }) => theme.secondaryText};
	}
	
	body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    // height: 100vh;
    // margin: 0;
    // padding: 0;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: all 0.25s linear;
  }`;
